import React, { useEffect, useRef, useState } from "react";
import { NavLink } from "react-router-dom";
import logo1 from "../../images/javian-logo-2026.png";
import "./navbar2.css";

const Navbar2 = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.pageYOffset > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (!menuOpen) return;
    const handleOutsideClick = (e) => {
      if (navRef.current && !navRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    document.addEventListener("touchstart", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      document.removeEventListener("touchstart", handleOutsideClick);
    };
  }, [menuOpen]);

  return (
    <nav
      ref={navRef}
      className={`glass-nav navbar navbar-expand-lg navbar-dark${
        scrolled ? " glass-nav--scrolled" : ""
      }`}
    >
      <div className="glass-nav__inner container-fluid">
        <a className="navbar-brand glass-nav__brand" href="/">
          <img src={logo1} alt="logo" height="34" />
        </a>
        <button
          className="navbar-toggler glass-nav__toggler"
          type="button"
          aria-controls="navbarNav"
          aria-expanded={menuOpen}
          aria-label="Toggle navigation"
          onClick={() => setMenuOpen((open) => !open)}
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div
          className={`collapse navbar-collapse glass-nav__links${
            menuOpen ? " show" : ""
          }`}
          id="navbarNav"
        >
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <NavLink exact className="nav-link glass-nav__link" to="/">
                <i className="fa-solid fa-house"></i>&nbsp;Home
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink className="nav-link glass-nav__link" to="/about/">
                <i className="fa-solid fa-circle-info"></i>&nbsp;About Me
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink className="nav-link glass-nav__link" to="/projects/">
                <i className="fa-solid fa-bars-progress"></i>&nbsp;Projects
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink className="nav-link glass-nav__link" to="/blogs/">
                <i className="fa-solid fa-blog"></i>&nbsp;Blogs
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar2;
